import { useQuery } from 'react-query';

import { getTrapDetailChartData } from 'api/traps/Trap/getTrapDetailChartData';

export const useGetTrapDetailChartData = (slug: string, type: string) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    'MCTDetailChartData',
    () => getTrapDetailChartData(slug, type),
    {
      refetchOnWindowFocus: false,
      refetchInterval: 5000,
    },
  );

  return { data, refetch, isLoading, isFetching };
};

export default useGetTrapDetailChartData;
